import { axiosPrivateInstance } from 'libs/axios';
import { GET_PRODUCT_GENERAL_DETAILS_BY_ID } from 'utils/serviceUrls';

const getProductGeneralDetailsByIDService = async (params: any) => {
	const paramData = {
		url: 'string',
		agent: 'string',
		encProductId: params,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(GET_PRODUCT_GENERAL_DETAILS_BY_ID, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default getProductGeneralDetailsByIDService;
